module.exports = __webpack_public_path__ + "img/5.bd72ad2e.png";